import axios from "axios";
import { isBagelAdmin } from "../../utils";
import { CurrentUser } from "../auth";

const API_BASE_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/global_collections/accounts";

export const getAllAccounts = async (currentUser: CurrentUser | null) => {
  try {
    const isBagelUser = isBagelAdmin(currentUser);
    if (!isBagelUser) {
      throw new Error("You are not authorized to access this resource");
    }

    const response = await axios.get(`${API_BASE_URL}/`);
    return response.data.accounts;
  } catch (e) {
    console.error("Error fetching accounts", e);
    throw e;
  }
}; 